import react, { useEffect, useState } from "react";
import CustomInput from "../../../../Component/BasicComponents/CustomInput";
import { Btn } from "../../../../AbstractElements";
import RouteDropdown from "../../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import {
  useAddOutletAddress,
  useAddressType,
  useAllTowns,
  useCityStateByTown,
  useOutletAddressById,
  useUpdateOutletAddress,
} from "../hooks/useCustomer";
import PaginatedRouteDropdown from "../../../../Component/BasicComponents/Dropdowns/PaginatedDropdownWrapper";
import { getTownFilter } from "../hooks/CustomerRepository";

interface prop {
  mode: "add" | "edit";
  modalClose: () => void;
  initialData?: Record<string, any>;
  OutletId:any
  customerId?: number;
   onSuccess?: () => void;
}

const AddressModal: React.FC<prop> = ({ mode, modalClose, initialData,OutletId,customerId,onSuccess }) => {
  const [addressType, setAddressType] = useState("");
  const [address, setAddress] = useState("");
  const [streetName, setStreetName] = useState("");
  const [town, setTown] = useState();
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [pincode, setPincode] = useState("");
  const [selectedTownOption, setSelectedTownOption] = useState<{ id: string; label: string } | null>(null);

  console.log('initialData in Address',OutletId)

  const { data: getOutletAddress } = useOutletAddressById({
    enabled: mode == "edit",
    params: {
      outletAddressId: initialData?.OutletAddressId,
    },
  });


  useEffect(() => {
  if (mode === "edit" && getOutletAddress?.data) {
    const data = getOutletAddress.data;

    setAddressType(data?.outletAddressData?.AddressName || "");
    setAddress(data?.outletAddressData?.OutletAddress || "");
    setStreetName(data?.outletAddressData?.OutletStreetName || "");
    setPincode(data?.outletAddressData?.OutletPincode || "");
    setCity(data?.outletAddressData?.OutletCity || "")
    setState((data?.outletAddressData?.OutletState || ""))

    // Set selected town option as an object (id + label)
    if (data?.outletAddressData?.Itownid && data?.outletAddressData?.TownName) {
      setSelectedTownOption({ id: String(data?.outletAddressData?.Itownid), label: `${data?.outletAddressData?.TownName} | ${data?.outletAddressData?.OutletCity}` });
    }
  }
}, [getOutletAddress, mode]);

const {mutate:addAddress}=useAddOutletAddress();
const {mutate:updateAddress}=useUpdateOutletAddress();


  const { data: AddressType } = useAddressType({
    enabled: true,
  });

  const { data: cityStateData } = useCityStateByTown({
    enabled: !!selectedTownOption,
    params: {
      townId: selectedTownOption ? selectedTownOption.id : "",
    },
  });

  useEffect(() => {
    if (cityStateData?.data) {
      setState(cityStateData?.data?.[0]?.StateName);
      setCity(cityStateData?.data?.[0]?.CityName);
    }
  }, [cityStateData]);

const handleSubmit=(e: React.FormEvent)=>{
  e.preventDefault();

  const payload:any = {
    outletId:customerId ?? OutletId,
    townId: selectedTownOption?.id,
    addressType,
    outletAddress: address,
    outletStreetName: streetName,
    outletCity: city,
    outletState: state,
    outletPincode: pincode,
  };
  // console.log('payload',payload)
 if (mode === "edit") {
    payload.outletAddressId = initialData?.OutletAddressId;
  }

  const mutationFn = mode === "edit" ? updateAddress : addAddress;
mutationFn(payload, {
  onSuccess: () => {
    if (onSuccess) {
      onSuccess(); // Notify parent
    } else {
      modalClose(); // Default fallback
    }
  },
  onError: (err) => {
    console.error(err);
  },
});
}


  const formatOptions = (dataObj: Record<string, string> = {}) =>
    Object.keys(dataObj || {}).map((key) => ({ id: key, label: dataObj[key] }));

  

  // Step 1: Create town options
  // const townOptions = formatOptions(allTowns?.data?.TownsData) || [];

  // Step 2: Find the selected town object from options
  // const selectedTown = townOptions.find((opt) => opt.id === String(town)) || null;

  return (
    <form onSubmit={handleSubmit}>
      <div className="container-fluid">
        <div className="col">
          <RouteDropdown
            DropdownHeading="Address Name"
            value={addressType}
            onChange={(value: any) => setAddressType(value)}
            options={formatOptions(AddressType?.data) || []}
          />
        </div>

        <div className="col">
          <label style={{ fontWeight: "500", marginTop: "8px" }}>Address</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Address"
            value={address}
            onChange={(e: any) => setAddress(e.target.value)}
          />
        </div>

        <div className="col">
          <label style={{ fontWeight: "500", marginTop: "8px" }}>
            Street Name
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Street Name"
            value={streetName}
            onChange={(e: any) => setStreetName(e.target.value)}
          />
        </div>

        <div className="row col-sm-12">
          <div className="col-6">
            <PaginatedRouteDropdown
              initialSelectedOptions={selectedTownOption}
              DropdownHeading="Town"
              placeholder="Select Town"
              fetchOptions={async (page: any, search: any) => {
                const res = await getTownFilter({
                  page,
                  limit: 10,
                  search: search || "",
                });
                return (
                  Object.keys(res?.data?.TownsData || {}).map((key) => ({
                    id: key,
                    label: res?.data?.TownsData[key],
                  }))
                );
              }}
              onChange={(val: any) => 
           
                setSelectedTownOption(val)
              }
            />
          </div>
          <div className="col-6">
            <label style={{ fontWeight: "500", marginTop: "8px" }}>City</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter city"
              value={city}
              readOnly
            />
          </div>
        </div>
        <div className="row mb-0 col-sm-12">
          <div className="col-6">
            <label style={{ fontWeight: "500", marginTop: "8px" }}>State</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter State"
              value={state}
              readOnly
            />
          </div>

          <div className="col-6">
            <label style={{ fontWeight: "500", marginTop: "8px" }}>
              Pincode
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Pincode"
              value={pincode}
              onChange={(e: any) => setPincode(e.target.value)}
            />
          </div>
        </div>
        {/* Buttons */}
        <div className="d-flex justify-content-start gap-2 mt-2">
          <Btn
            style={{ backgroundColor: "#43B9B2", color: "white" }}
            type="submit"
          >
            {mode === "add" ? "Submit" : "Update"}
          </Btn>
          <Btn
            type="button"
            onClick={modalClose}
            style={{ backgroundColor: "#F9FAFC", color: "#000" }}
          >
            Cancel
          </Btn>
        </div>
      </div>

      
    </form>
  );
};

export default AddressModal;
